import React from 'react';
import { Icon } from '@chakra-ui/react';
import { FaChargingStation, FaUsers } from 'react-icons/fa';
import { GrUserAdmin } from 'react-icons/gr';
import {
  MdAddHome,
  MdHome,
  MdOutlineEvStation,
  MdPerson,
  MdAssignment,
  MdError,
  MdOutlineAssessment,
} from 'react-icons/md';
import MainDashboard from 'views/admin/default';
import Profile from 'views/admin/profile';
import MerchantDetail from 'views/admin/merchantPages/MerchantDetail';
import PowerBankAddEdit from 'views/admin/powerBankPages/PowerBankAddEdit';
import PowerBankDetails from 'views/admin/powerBankPages/PowerBankDetails';
import PowerBankList from 'views/admin/powerBankPages/PowerBankList';
import StationAddEdit from 'views/admin/stationPages/StationAddEdit';
import StationDetail from 'views/admin/stationPages/StationDetail';
import StationList from 'views/admin/stationPages/StationList';
import UserDetails from 'views/admin/usersPages/UserDetails';
import UserEdit from 'views/admin/usersPages/UserEdit';
import UserList from 'views/admin/usersPages/UserList';
import MerchantAddEdit from './views/admin/merchantPages/MerchantAddEdit';
import MerchantList from './views/admin/merchantPages/MerchantList';
import OrderList from 'views/admin/orderPages/OrderList';
import OrderDetail from 'views/admin/orderPages/OrderDetail';
import AdminUserTabs from 'views/admin/adminUserPages/AdminUserTabs';
import AdminUserAddEdit from 'views/admin/adminUserPages/AdminUserAddEdit';
import AdminUserDetail from 'views/admin/adminUserPages/AdminUserDetail';
import { sideBarRoutes } from 'utils/StaticData';
import SystemErrorsList from 'views/admin/systemErrors/SystemErrorsList';
import ProfitabilityAnalysisGraph from 'views/admin/profitabilityAnalysis/ProfitabilityAnalysisGraph';
import { RiBillLine } from 'react-icons/ri';
import SettlementsList from 'views/admin/settlementModule/SettlementsList';
import { RiCoupon2Line, RiPriceTag3Line } from 'react-icons/ri';
import CouponList from 'views/admin/couponPages/CouponList';
import CouponAddEdit from 'views/admin/couponPages/CouponAddEdit';
import CouponDetail from 'views/admin/couponPages/CouponDetail';
import { FaFileInvoice } from 'react-icons/fa';
import EInvoiceTabs from 'views/admin/invoicePages/EInvoiceTabs';
import EInvoiceDetail from 'views/admin/invoicePages/EInvoiceDetail';
import CustomerInvoiceDetail from 'views/admin/invoicePages/CustomerInvoiceDetail';
import PriceStrategyList from 'views/admin/priceStrategy/PriceStrategyList';
import AddEditPriceStrategy from 'views/admin/priceStrategy/AddEditPriceStrategy';
import PriceStrategyDetail from 'views/admin/priceStrategy/PriceStrategyDetail';
import PayoutSettingList from 'views/admin/payoutSetting/PayoutSettingList';
import CreatePayoutSetting from 'views/admin/payoutSetting/CreatePayoutSetting';
import PayoutSettingDetail from 'views/admin/payoutSetting/PayoutSettingDetail';
import EditPayoutSetting from 'views/admin/payoutSetting/EditPayoutSetting';
import PayoutLogList from 'views/admin/payoutSetting/PayoutLogList';

const routes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/dashboard',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: false,
  },

  //////  Admin User Module /////
  {
    name: 'Portal Users',
    layout: '/admin',
    path: '/admin-users',
    icon: <Icon as={GrUserAdmin} width="20px" height="20px" color="inherit" />,
    component: <AdminUserTabs />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: false,
  },
  {
    name: 'Add Portal User',
    layout: '/admin',
    path: '/admin-users/add',
    icon: <Icon as={GrUserAdmin} width="20px" height="20px" color="inherit" />,
    component: <AdminUserAddEdit />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },
  {
    name: 'Edit User',
    layout: '/admin',
    path: '/admin-users/edit/:adminEditUserId',
    icon: <Icon as={GrUserAdmin} width="20px" height="20px" color="inherit" />,
    component: <AdminUserAddEdit />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },
  {
    name: 'User Details',
    layout: '/admin',
    path: '/admin-users/details/:adminUserDetailId',
    icon: <Icon as={GrUserAdmin} width="20px" height="20px" color="inherit" />,
    component: <AdminUserDetail />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },

  //////   User Module ////
  {
    name: 'Users',
    layout: '/admin',
    path: '/users',
    icon: <Icon as={FaUsers} width="20px" height="20px" color="inherit" />,
    component: <UserList />,
    roles: [sideBarRoutes?.Admin],
    hidden: false,
  },
  {
    name: 'Add User',
    layout: '/admin',
    path: '/users/add',
    icon: <Icon as={FaUsers} width="20px" height="20px" color="inherit" />,
    component: <UserEdit />,
    roles: [sideBarRoutes?.Admin],
    hidden: true,
  },
  {
    name: 'Edit User',
    layout: '/admin',
    path: '/users/edit/:editUserId',
    icon: <Icon as={FaUsers} width="20px" height="20px" color="inherit" />,
    component: <UserEdit />,
    roles: [sideBarRoutes?.Admin],
    hidden: true,
  },
  {
    name: 'User Details',
    layout: '/admin',
    path: '/users/details/:userDetailId',
    icon: <Icon as={FaUsers} width="20px" height="20px" color="inherit" />,
    component: <UserDetails />,
    roles: [sideBarRoutes?.Admin],
    hidden: true,
  },

  ///// Merchant Module ///
  {
    name: 'Merchants',
    layout: '/admin',
    path: '/merchants',
    icon: <Icon as={MdAddHome} width="20px" height="20px" color="inherit" />,
    component: <MerchantList />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: false,
  },
  {
    name: 'Add Merchant',
    layout: '/admin',
    path: '/merchants/add',
    icon: <Icon as={MdAddHome} width="20px" height="20px" color="inherit" />,
    component: <MerchantAddEdit />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },
  {
    name: 'Edit Merchant',
    layout: '/admin',
    path: '/merchants/edit/:editmerchantId',
    icon: <Icon as={MdAddHome} width="20px" height="20px" color="inherit" />,
    component: <MerchantAddEdit />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },
  {
    name: 'Merchant Details',
    layout: '/admin',
    path: '/merchants/details/:merchantDetailId',
    icon: <Icon as={MdAddHome} width="20px" height="20px" color="inherit" />,
    component: <MerchantDetail />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },

  /////// Station Module /////
  {
    name: 'Stations',
    layout: '/admin',
    path: '/stations',
    icon: (
      <Icon as={FaChargingStation} width="20px" height="20px" color="inherit" />
    ),
    component: <StationList />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: false,
  },
  {
    name: 'Add Station',
    layout: '/admin',
    path: '/stations/add',
    icon: (
      <Icon as={FaChargingStation} width="20px" height="20px" color="inherit" />
    ),
    component: <StationAddEdit />,
    roles: [sideBarRoutes?.Admin],
    hidden: true,
  },
  {
    name: 'Edit Station',
    layout: '/admin',
    path: '/stations/edit/:editStationId',
    icon: (
      <Icon as={FaChargingStation} width="20px" height="20px" color="inherit" />
    ),
    component: <StationAddEdit />,
    // roles: [sideBarRoutes?.Admin],
    hidden: true,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
  },
  {
    name: 'Station Details',
    layout: '/admin',
    path: '/stations/details/:stationDetailId',
    icon: (
      <Icon as={FaChargingStation} width="20px" height="20px" color="inherit" />
    ),
    component: <StationDetail />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },

  {
    name: 'Price Strategy',
    layout: '/admin',
    path: '/price-strategy',
    icon: (
      <Icon as={RiPriceTag3Line} width="20px" height="20px" color="inherit" />
    ),
    component: <PriceStrategyList />,
    roles: [sideBarRoutes?.Admin, sideBarRoutes?.Dealer],
    hidden: false,
  },
  {
    name: 'Add Price Strategy',
    layout: '/admin',
    path: '/price-strategy/add',
    icon: (
      <Icon as={RiPriceTag3Line} width="20px" height="20px" color="inherit" />
    ),
    component: <AddEditPriceStrategy />,
    roles: [sideBarRoutes?.Admin, sideBarRoutes?.Dealer],
    hidden: true,
  },
  {
    name: 'Edit Price Strategy',
    layout: '/admin',
    path: '/price-strategy/edit/:editPriceStrategyId',
    icon: (
      <Icon as={RiPriceTag3Line} width="20px" height="20px" color="inherit" />
    ),
    component: <AddEditPriceStrategy />,
    roles: [sideBarRoutes?.Admin, sideBarRoutes?.Dealer],
    hidden: true,
  },
  {
    name: 'Price Strategy Details',
    layout: '/admin',
    path: '/price-strategy/details/:priceStrategyDetailId',
    icon: (
      <Icon as={RiPriceTag3Line} width="20px" height="20px" color="inherit" />
    ),
    component: <PriceStrategyDetail />,
    roles: [sideBarRoutes?.Admin, sideBarRoutes?.Dealer],
    hidden: true,
  },

  ///////// PowerBank Detail //////
  {
    name: 'Powerbanks',
    layout: '/admin',
    path: '/powerbanks',
    icon: (
      <Icon
        as={MdOutlineEvStation}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <PowerBankList />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: false,
  },
  {
    name: 'Add Powerbank',
    layout: '/admin',
    path: '/powerbanks/add',
    icon: (
      <Icon
        as={MdOutlineEvStation}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <PowerBankAddEdit />,
    roles: [sideBarRoutes?.Admin],
    hidden: true,
  },
  {
    name: 'Edit Powerbank',
    layout: '/admin',
    path: '/powerbanks/edit/:editpowerbanksId',
    icon: (
      <Icon
        as={MdOutlineEvStation}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <PowerBankAddEdit />,
    roles: [sideBarRoutes?.Admin],
    hidden: true,
  },
  {
    name: 'Powerbank Details',
    layout: '/admin',
    path: '/powerbanks/details/:powerbanksDetailId',
    icon: (
      <Icon
        as={MdOutlineEvStation}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <PowerBankDetails />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },

  ////// E-Invoice Module ///
  {
    name: 'E-Invoice',
    layout: '/admin',
    path: '/e-invoices',
    icon: (
      <Icon as={FaFileInvoice} width="20px" height="20px" color="inherit" />
    ),
    component: <EInvoiceTabs />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: false,
  },
  {
    name: 'Merchant E-Invoice Details',
    layout: '/admin',
    path: '/e-invoices/merchant-details/:invoiceDetailId',
    icon: (
      <Icon as={FaFileInvoice} width="20px" height="20px" color="inherit" />
    ),
    component: <EInvoiceDetail />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },
  {
    name: 'Customer E-Invoice Details',
    layout: '/admin',
    path: '/e-invoices/customer-details/:invoiceDetailId',
    icon: (
      <Icon as={FaFileInvoice} width="20px" height="20px" color="inherit" />
    ),
    component: <CustomerInvoiceDetail />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },

  ////// Order Module ///
  {
    name: 'Orders',
    layout: '/admin',
    path: '/orders',
    icon: <Icon as={MdAssignment} width="20px" height="20px" color="inherit" />,
    component: <OrderList />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: false,
  },
  {
    name: 'Orders Details',
    layout: '/admin',
    path: '/orders/details/:ordersDetailId',
    icon: <Icon as={MdAssignment} width="20px" height="20px" color="inherit" />,
    component: <OrderDetail />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },

  /////// Statement Module ///////
  {
    name: 'Settlements',
    layout: '/admin',
    path: '/settlements',
    icon: <Icon as={RiBillLine} width="20px" height="20px" color="inherit" />,
    component: <SettlementsList />,
    roles: [sideBarRoutes?.Admin, sideBarRoutes?.Dealer],
    hidden: false,
  },

  /////// Coupons Module ///////
  {
    name: 'Coupons',
    layout: '/admin',
    path: '/coupons',
    icon: (
      <Icon as={RiCoupon2Line} width="20px" height="20px" color="inherit" />
    ),
    component: <CouponList />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: false,
  },
  {
    name: 'Add Coupon',
    layout: '/admin',
    path: '/coupons/add',
    icon: (
      <Icon as={RiCoupon2Line} width="20px" height="20px" color="inherit" />
    ),
    component: <CouponAddEdit />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },
  {
    name: 'Edit Coupon',
    layout: '/admin',
    path: '/coupons/edit/:editCouponId',
    icon: (
      <Icon as={RiCoupon2Line} width="20px" height="20px" color="inherit" />
    ),
    component: <CouponAddEdit />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },
  {
    name: 'Coupon Details',
    layout: '/admin',
    path: '/coupons/details/:couponDetailId',
    icon: (
      <Icon as={RiCoupon2Line} width="20px" height="20px" color="inherit" />
    ),
    component: <CouponDetail />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },

  ///////////// Profitability Analysis ////////////
  {
    name: 'Profitability Analysis',
    layout: '/admin',
    path: '/profitability-analysis',
    icon: (
      <Icon
        as={MdOutlineAssessment}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <ProfitabilityAnalysisGraph />,
    roles: [sideBarRoutes?.Admin],
    hidden: false,
  },

  /////// System Error Module /////
  {
    name: 'System Errors',
    layout: '/admin',
    path: '/system-errors',
    icon: (
      <Icon
        as={MdError}
        width="20px"
        height="20px"
        color="inherit"
        display="block"
      />
    ),
    component: <SystemErrorsList />,
    roles: [sideBarRoutes?.Admin],
    hidden: false,
  },

  /////// Payout Settings Module ///////
  {
    name: 'Payout Settings',
    layout: '/admin',
    path: '/payout-settings',
    icon: <Icon as={RiBillLine} width="20px" height="20px" color="inherit" />,
    component: <PayoutSettingList />,
    roles: [sideBarRoutes?.Admin, sideBarRoutes?.Dealer],
    hidden: false,
  },
  {
    name: 'Create Payout Setting',
    layout: '/admin',
    path: '/payout-settings/create',
    icon: <Icon as={RiBillLine} width="20px" height="20px" color="inherit" />,
    component: <CreatePayoutSetting />,
    roles: [sideBarRoutes?.Admin],
    hidden: true,
  },
  {
    name: 'Payout Setting Detail',
    layout: '/admin',
    path: '/payout-settings/:payoutSettingDetailId',
    icon: <Icon as={RiBillLine} width="20px" height="20px" color="inherit" />,
    component: <PayoutSettingDetail />,
    roles: [sideBarRoutes?.Admin, sideBarRoutes?.Dealer],
    hidden: true,
  },
  {
    name: 'Edit Payout Setting',
    layout: '/admin',
    path: '/payout-settings/:payoutSettingEditId/edit',
    icon: <Icon as={RiBillLine} width="20px" height="20px" color="inherit" />,
    component: <EditPayoutSetting />,
    roles: [sideBarRoutes?.Admin],
    hidden: true,
  },

  /////// Payout Logs Module ///////
  {
    name: 'Payout Logs',
    layout: '/admin',
    path: '/payout-logs',
    icon: <Icon as={RiBillLine} width="20px" height="20px" color="inherit" />,
    component: <PayoutLogList />,
    roles: [sideBarRoutes?.Admin, sideBarRoutes?.Dealer],
    hidden: false,
  },

  /////// Profile Module /////
  {
    name: 'Profile',
    layout: '/admin',
    path: '/profile',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <Profile />,
    roles: [
      sideBarRoutes?.Admin,
      sideBarRoutes?.Merchant,
      sideBarRoutes?.Seller,
      sideBarRoutes?.Organization,
      sideBarRoutes?.Dealer,
    ],
    hidden: true,
  },
];

export default routes;
